export const adempimentiClosed = (period, tipo, isAdmin = false) => {
  if (String(tipo || '').toUpperCase() === 'B') {
    return Boolean(period?.bpoint_adempimenti_invoice_closed)
      || (!isAdmin && Boolean(period?.chiuso_sez3_bpoint));
  }
  return period?.stato === 'chiuso' || (!isAdmin && Boolean(period?.chiuso_sez3));
};
